export default __webpack_public_path__ + "images/onboarding/fidget-33a6e62a910fcd7102c440a1110ed75f.svg";